// extracted by mini-css-extract-plugin
export default {"wrapper":"ViewAsComponent_wrapper__Uuv45"};